import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Pricing from "@/pages/Pricing";
import Playground from "@/pages/Playground";
import Dashboard from "@/pages/Dashboard";
import Checkout from "@/pages/Checkout";
import Terms from "@/pages/Terms";
import Download from "@/pages/Download";
import PluginShowcase from "@/pages/PluginShowcase";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminPlugin from "@/pages/admin/AdminPlugin";
import AdminSubscriptions from "@/pages/admin/AdminSubscriptions";
import AdminAiEngine from "@/pages/admin/AdminAiEngine";
import AdminMarketplace from "@/pages/admin/AdminMarketplace";
import AdminCommunity from "@/pages/admin/AdminCommunity";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import AdminWebhooks from "@/pages/admin/AdminWebhooks";

function Shell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Nav />}
      <main className={isAdmin ? "" : "min-h-[calc(100vh-4rem)]"}>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-bg text-white">
      <AuthProvider>
        <BrowserRouter>
          <Shell>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/playground" element={<Playground />} />
              <Route path="/plugin" element={<PluginShowcase />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/download" element={<Download />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminOverview />} />
                <Route path="subscriptions" element={<AdminSubscriptions />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="plugin" element={<AdminPlugin />} />
                <Route path="ai-engine" element={<AdminAiEngine />} />
                <Route path="marketplace" element={<AdminMarketplace />} />
                <Route path="community" element={<AdminCommunity />} />
                <Route path="security" element={<AdminSecurity />} />
                <Route path="webhooks" element={<AdminWebhooks />} />
              </Route>
            </Routes>
          </Shell>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
